import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--image" icon='image'>{ children ? children : 'Image' }</Button>
}